












































































































































































import Vue from 'vue';
import api from '@/shared/api';
import DateTimePicker from '@/components/DateTimePicker.vue';
import Select1 from '@/components/Select1.vue';
import { Incident } from '@/shared/api/types';

type FollowUp = {
  Date: Date;
  Note: string | null;
};

interface Props {
  incident: Incident;
  action: string;
  canEdit: boolean;
}

interface Data {
  loading: boolean;
  followUp: FollowUp[];
  selectOptions: [
    {
      value: 'ChronicEpisode';
      label: 'Chronic Mental Health Episode';
    },
    {
      value: 'AcuteEpisode';
      label: 'Acute Mental Health Concern/Episode';
    },
    {
      value: 'SituationalCrisis';
      label: 'Situational Crisis';
    },
    {
      value: 'SocialIssue';
      label: 'Social Issue';
    },
    {
      value: 'Other';
      label: 'Other';
    }
  ];
  concernMap: {
    ChronicEpisode: 'Chronic Mental Health Episode';
    AcuteEpisode: 'Acute Mental Health Concern/Episode';
    SituationalCrisis: 'Situational Crisis';
    SocialIssue: 'Social Issue';
    Other: 'Other';
  };
}

interface Methods {
  save: () => Promise<void>;
  addFollowUp: () => void;
  deleteFollowUp: (item: FollowUp) => void;
  getConcernString: (concerns: Array<keyof Data['concernMap']>) => string;
}

export default Vue.extend<Data, Methods, {}, Props>({
  props: {
    incident: {},
    action: {},
    canEdit: {}
  },
  components: {
    DateTimePicker,
    Select1
  },
  data () {
    return {
      loading: false,
      followUp: [],
      selectOptions: [
        {
          value: 'ChronicEpisode',
          label: 'Chronic Mental Health Episode'
        },
        {
          value: 'AcuteEpisode',
          label: 'Acute Mental Health Concern/Episode'
        },
        {
          value: 'SituationalCrisis',
          label: 'Situational Crisis'
        },
        {
          value: 'SocialIssue',
          label: 'Social Issue'
        },
        {
          value: 'Other',
          label: 'Other'
        }
      ],
      concernMap: {
        ChronicEpisode: 'Chronic Mental Health Episode',
        AcuteEpisode: 'Acute Mental Health Concern/Episode',
        SituationalCrisis: 'Situational Crisis',
        SocialIssue: 'Social Issue',
        Other: 'Other'
      }
    };
  },
  mounted () {
    if (this.incident.FollowUp) {
      this.followUp = JSON.parse(this.incident.FollowUp);
    }
  },
  watch: {
    followUp: {
      handler () {
        this.incident.FollowUp = JSON.stringify(this.followUp);
      },
      deep: true
    },
    incident: {
      async handler () {
        if (this.action === 'edit') await this.save();
      },
      deep: true
    }
  },
  methods: {
    save: async function () {
      const method = this.action === 'create' ? 'post' : 'patch';
      this.loading = true;

      const result = await api.upsertIncident(method, this.incident);
      if (result && result.status === 200 && method === 'post') {
        this.loading = false;
        if (result.data.PrincipalID) {
          this.$router.push({
            path: `/incidents/edit/${result.data.PrincipalID}`
          });
        }
      }
      // TODO go somewhere afterwards..
      // slight issue where the season is not in url or anything, so the selection on the list page would default back to "current"
    },
    addFollowUp: function () {
      this.followUp.push({ Date: new Date(), Note: null });
    },
    deleteFollowUp: function (item) {
      this.followUp = this.followUp.filter(function (fItem) {
        return fItem.Date !== item.Date;
      });
    },
    getConcernString: function (concerns) {
      if (concerns) {
        return concerns.map(c => this.concernMap[c] || '').join(', ');
      }

      return '';
    }
  }
});
